@use "@fukuri-admins/ui/layout" as *;

.emptyTable {
  font-size: 40px;
  color: $NATURAL_400;
  text-align: center;
  margin: 100px auto;
  height: 326px;
}
